<template>
  <div
    class="-custom-video-overlays wt2-sg wt-custom-overlay-fields -metadata-editor"
  >
    <div class="video-info-title -subtitle wt2-text-l2 wt2-color-normal">
      Custom Video Settings
    </div>
    <div v-for="customOverlay in customOverlays" :key="customOverlay.id">
      <p>
        <span
          class="-co-title wt2-color-normal"
          v-text="customOverlay.displayText"
        />
        <template v-for="(field, index) in customOverlay.fields">
          <custom-video-overlays-fields
            :field="field"
            :allowStoryboardingControls="false"
            :customOverlay="customOverlay"
            @change="onFieldValueChange"
          />
        </template>
      </p>
    </div>
  </div>
</template>

<script>
import CustomVideoOverlaysFields from './CustomVideoOverlaysFields.vue';
import app from 'app';
import Vue from 'vue';

export default Vue.extend({
  name: 'CustomVideoOverlays',
  store: app.rootStore,
  props: {
    customOverlaysPresets: {
      type: Array,
      required: true,
    },
    customOverlayValues: {
      type: Array,
      required: true,
    },
  },
  components: {
    CustomVideoOverlaysFields,
  },
  data() {
    return {
      customOverlays: [],
    };
  },
  created() {
    this.customOverlays = this.customOverlayValues
      ?.filter((co) => !co.disabled)
      ?.map((customOverlayValue) => {
        const customOverlayPreset = this.customOverlaysPresets?.find(
          (overlay) => overlay.id === customOverlayValue.id
        );
        if (!customOverlayPreset) {
          console.error(
            `Video Custom overlay with id ${customOverlayValue.id} not found in presets`
          );
          return;
        }
        customOverlayPreset.fields = customOverlayPreset.fields?.map(
          (field) => {
            const fieldValue = customOverlayValue.fields.find(
              (customOverlayField) => customOverlayField.name === field.name
            );
            if (fieldValue) {
              field.value = fieldValue.value;
            }
            return field;
          }
        );
        return customOverlayPreset;
      });
  },
  mounted() {
    if (!this.customOverlays.length) {
      this.destroy();
    }
  },
  methods: {
    onFieldValueChange(valueChanges) {
      const { customOverlayId, name, value, type } = valueChanges;
      const customOverlayValue = this.customOverlayValues?.find(
        (customOverlay) => customOverlay.id === customOverlayId
      );
      if (customOverlayValue) {
        const field = customOverlayValue.fields.find(
          (field) => field.name === name
        );
        if (field) {
          field.value = value;
        }
      }
      this.$emit('change', valueChanges);
    },
    isArray(field) {
      return _.isArray(field);
    },
    destroy() {
      this.$destroy();
      this.$el.remove();
    },
  },
});
</script>

<style lang="scss" scoped>
.-co-title {
  display: inline-block;
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 20px;
}
</style>
